/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: InGameHeader.tsx
 *
 * Written by Sterios Taskudis <sterios.taskudis@egt-digital.com> on  10.04.24 12:03 pm.
 * Last modified: 10.04.24 12:03 pm.
 *
 * More information at: https://egt-digital.com/
 */

import React from 'react';
import Search from '../NavigationBar/Search';
import { addBuildHash } from '../api/helpers';
import { useSettings } from '../contexts/SettingsContext';
import store from '../eventStore';
import { setSearchBy } from '../api';
import { LOBBY_SECTION_NAME, SCROLL_POS_STORAGE_KEY } from '../constants';
import { useSectionContainerRef } from '../contexts/SectionContainerRefContext';

const InGameHeader = () => {
    const [settings, setSettings] = useSettings();
    const [sectionContainerRef] = useSectionContainerRef();

    const onClickClose = () => {
        setSettings?.({
            ...settings,
            // Close the search
            isSearchOpen: false,
            // Reset the selected section
            selectedSection: LOBBY_SECTION_NAME,
        });

        // Clear the scroll data
        store.SCROLL_STORAGE.next({
            selectedSection: LOBBY_SECTION_NAME,
            sections: {},
            scrollHeight: 0,
        });

        // Clear local storage scroll data
        store.SAVE_GAME_DATA_TO_LOCAL_STORAGE.next({
            key: SCROLL_POS_STORAGE_KEY,
            data: null,
        });

        // Reset the Section container scroll position
        if (sectionContainerRef?.current?.scrollTop) {
            sectionContainerRef.current.scrollTop = 0;
        }

        // Clear search input field
        setSearchBy('');

        store.EXTERNAL_CHANNEL.next({
            event: 'display',
            value: false,
        });
    };

    const onClickSearch = () => {
        const newSettings = {
            ...settings,
            isSearchOpen: !settings.isSearchOpen,
            isSettingsModalOpen: false,
        };

        setSettings?.(newSettings);
    };

    const onClickBack = () => {
        setSettings?.({
            ...settings,
            isSearchOpen: false,
        });
    };

    if (store.SETTINGS.value?.openType !== 'ingame') {
        return null;
    }

    return (
        <div id="title" className={`egtd-lobby-title ${settings.isSearchOpen ? 'active-search' : ''}`}>
            <img
                onClick={onClickBack}
                className="egt_search_component_close"
                src={addBuildHash(`${settings.host}/assets/portal/ui/back.svg`)}
                alt=""
            />

            <Search
                onClick={onClickSearch}
                active={settings.isSearchOpen}
                // className={settings.mode === 'mobile' ? 'portrait-only' : ''}
            />

            <span>LOBBY</span>
            <img
                src={addBuildHash(`${store.SETTINGS.value.host}/assets/portal/ui/popupCloseRed.svg`)}
                className="egtd-popup-close-icon-button"
                onClick={onClickClose}
                alt=""
            />
        </div>
    );
};

export default InGameHeader;
